import OpenAI from "openai";

const openai = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    dangerouslyAllowBrowser: true
});


export async function getGPTResponse(durationVal, genre) {
  try {
    const chatCompletion = await openai.chat.completions.create({
      messages: [
        { role: "system", content: "You are a helpful playlist-generating assistant that follows all the requirements and directives of the user, specifically the total length of the playlist." },
        {
          role: "user",
          content: "Respond with a music playlist of " + genre + " genre whose total duration of all the songs in it combined is about " + Math.round(parseFloat(durationVal)) + " minutes. Only respond with the 'artist name - song title' format, don't add anything extra before or after the playlist or each song including numbers. Give us a minimum of " + Math.round(parseFloat(durationVal) / 4.5) + " songs."
        },
      ],
      model: "gpt-3.5-turbo-0125",
    });

    console.log('GPT response:', chatCompletion.choices[0].message.content); // Debugging statement

    return chatCompletion.choices[0].message.content;
  } catch (error) {
    console.error('Error fetching GPT response:', error);
    throw error;
  }
}
